import {Base} from "@/api/Base"

export class SalaryEdit extends Base {
    path = "salary/edit"
}